import { IMaskInput } from "react-imask";
import { FiInfo } from "react-icons/fi";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { useState, useEffect } from "react";

interface MaskedInputProps {
  label?: string;
  labelColor?: string;
  labelSize?: string;
  labelWeight?: string;
  value?: string;
  onChange?: (e: any) => void;
  errorMessage?: string;
  toolTipText?: string;
  requiredMark?: boolean;
  disabled?: boolean;
  name: string;
  placeholder?: string;
}

export const MaskedInputCPF = ({
  label,
  value,
  onChange,
  errorMessage,
  toolTipText,
  requiredMark,
  disabled,
  name,
  placeholder,
  labelSize = "base",
  labelColor = "gray-700",
  labelWeight = "semibold",
}: MaskedInputProps) => {
  const [hasValue, setHasValue] = useState(false);

  // Cria ID único para tooltip
  const tooltipId = `tooltip-${label && label.replace(/\s+/g, "-").toLowerCase()}`;

  useEffect(() => {
    setHasValue(!!value);
  }, [value]);

  return (
    <div className="w-full">
      {label && (
        <label className={`text-${labelSize} font-${labelWeight} text-${labelColor} flex items-center gap-1`}>
          {label}
          {requiredMark && <span className="text-red-500 font-bold">*</span>}
          {toolTipText && (
            <>
              <FiInfo
                className="text-blue-500 hover:text-white hover:bg-blue-500 rounded-full cursor-pointer ml-1"
                data-tooltip-id={tooltipId}
              />
              <ReactTooltip
                id={tooltipId}
                place="top"
                content={toolTipText}
                className="z-50"
              />
            </>
          )}
        </label>
      )}

      <div className="flex">
        <IMaskInput
        mask={[
            { mask: "000.000.000-00" },
            { mask: "00.000.000/0000-00" },
        ]}
        name={name}
        value={value}
        onAccept={(val: any) =>
            onChange?.({ target: { name, value: val } })
        }
        disabled={disabled}
        placeholder={placeholder}
        className={`w-full px-4 mt-1 py-2 h-[42px] rounded-lg border bg-white disabled:cursor-not-allowed
            ${errorMessage ? "border-red-500" : "border-gray-300"}
            placeholder-gray-400 focus:outline-none focus:ring-1 focus:ring-blue-300
            ${hasValue ? "text-gray-700" : "text-gray-400"} disabled:opacity-50`}
        />

      </div>

      {errorMessage && (
        <p className="text-red-500 text-sm mt-1">{errorMessage}</p>
      )}
    </div>
  );
};
